"use client";

import { createContext, use } from "react";

import type { UserForClient } from "@/lib/supabase/repository/user";

export const userContext = createContext<UserForClient | null>(null);

export function useUser() {
  return use(userContext);
}

export function useIsNcm() {
  const user = useUser();

  if (user === null || user.is_ncm !== true) {
    return false;
  }

  return true;
}

export function useIsAdmin() {
  const user = useUser();

  if (user === null || user.is_admin !== true) {
    return false;
  }

  return true;
}
